import ListGroup from 'react-bootstrap/ListGroup';
import { MdAccessTime } from 'react-icons/md';

const WordListItem = ({ entry, active, onClick, dataLetter }) => {
  const isDisabled = !entry.hasDef || entry.type === 'custom';
  return (
    <ListGroup.Item
      key={entry.id}
      action={!isDisabled}
      active={active}
      onClick={!isDisabled && onClick ? () => onClick(entry) : undefined}
      disabled={isDisabled}
      data-letter={dataLetter}
      className='d-flex justify-content-between align-items-center'
    >
      <span>{entry.word}</span>
      {isDisabled && (
        <MdAccessTime
          size={16}
          color='rgb(142, 61, 255)'
          title='Coming soon'
          style={{ marginLeft: '8px', flexShrink: 0 }}
        />
      )}
    </ListGroup.Item>
  );
};

export default WordListItem;
